import {UserInfoContainer} from './components/user-info-container';

export default {
    component: UserInfoContainer
};
